import React from 'react';

export default function Bookshelf({ size, color }) {
  return (
    <svg width={size} height={size} fill={color} viewBox='0 0 24 24'>
      <path d='M9 3V18H12V3H9M12 5L16 18L19 17L15 4L12 5M5 5V18H8V5H5M3 19V21H21V19H3Z' />
    </svg>
  );
}
